import OrderBaseProxy from '@/proxies/Order/OrderBaseProxy';
import OrderComplexProxy from '@/proxies/Order/OrderComplexProxy';
import snackbarMixin from '@/mixins/snackbarMixin';
import  * as order_paybale_types from '@/constants/payable';

export default {
    mixins: [
        snackbarMixin,
    ],
    methods: {
        requestUpdateCleaners(type, ordeId, cleaners) {
            if (![order_paybale_types.ORDERS_BASE, order_paybale_types.ORDERS_COMPLEX].includes(type)) {
                return;
            }
            const cleanerId = cleaners.map(item => item.uuid);
            const data = {cleaners_uuid: cleanerId};
            const proxy = type === order_paybale_types.ORDERS_BASE ? (new OrderBaseProxy()) : (new OrderComplexProxy());
            proxy.update(ordeId, data);
        },
        deleteCleaner(type, order, cleanerId) {
            if (![order_paybale_types.ORDERS_BASE, order_paybale_types.ORDERS_COMPLEX].includes(type)) {
                return;
            }
            this.paginatedObject.data = this.paginatedObject.data.map(item => {
                if (item.uuid === order.uuid) {
                    const index = item.cleaners.findIndex(n => n.uuid === cleanerId);
                    item.cleaners.splice(index, 1);
                    this.requestUpdateCleaners(type, order.uuid, item.cleaners);
                }
                return item;
            });
        },
        selectCleaner(type, order, cleaner) {
            if (![order_paybale_types.ORDERS_BASE, order_paybale_types.ORDERS_COMPLEX].includes(type)) {
                return;
            }
            if (cleaner.has_order) {
                this.showSnackbar(this.lang(this.$store, 'sap/listings.global.cleaner_has_order'), 'red');
                return;
            }
            const paginatedObjectData = this.paginatedObject.data.map(item => {
                if (item.uuid === order.uuid) {
                    let index = !('cleaners' in item) ? -1 : item.cleaners.findIndex(n => n.uuid === cleaner.uuid);
                    if (index > -1) {
                        this.$store.dispatch('page/displaySnackbar', {
                            text: this.lang(this.$store, 'sap/listings.global.cleaner_already_exist'),
                            color: 'pink darken-3',
                        });
                    } else {
                        if(!('cleaners' in item)) {
                            this.$set(item, 'cleaners', []);
                        }
                        item.cleaners.push(cleaner);
                        this.requestUpdateCleaners(type, order.uuid, item.cleaners);
                    }
                }
                return item;
            });
            this.$emit('renew', paginatedObjectData)
        },
    },
};